import { StyledHelper } from './styledHelper'

export const grey = (color: number): StyledHelper => () => `rgba(0, 0, 0, ${1 - (color / 0xFF)})`